import React from "react";

export default function KeyFeatures() {
	return (
		<div className="px-6 mx-auto bg-gradient-to-b from-purple-50 to-pink-50">
			<section className="container py-8 mx-auto">
				<h2 className="text-5xl p-6 font-extrabold text-center bg-gradient-to-r from-purple-600 via-pink-500 to-purple-600 bg-clip-text text-transparent mb-16 animate-gradient">
					What Makes Us Extraordinary
				</h2>

				<div className="grid md:grid-cols-3 gap-12">
					{/* Feature 1 */}
					<div className="group relative overflow-hidden rounded-3xl bg-gradient-to-br from-purple-500 to-pink-400 p-1">
						<div className="bg-white rounded-3xl p-8 h-full">
							<div className="relative">
								<span className="mb-6 inline-block rounded-2xl bg-gradient-to-r from-purple-500 to-pink-400 p-4">
									<svg
										className="h-8 w-8 text-white"
										xmlns="http://www.w3.org/2000/svg"
										viewBox="0 0 512 512"
									>
										<path
											fill="currentColor"
											d="M192 208c0-17.67-14.33-32-32-32h-16c-35.35 0-64 28.65-64 64v48c0 35.35 28.65 64 64 64h16c17.67 0 32-14.33 32-32V208zm176 144c35.35 0 64-28.65 64-64v-48c0-35.35-28.65-64-64-64h-16c-17.67 0-32 14.33-32 32v112c0 17.67 14.33 32 32 32h16z"
										/>
									</svg>
								</span>
								<h3 className="mb-4 text-2xl font-bold bg-gradient-to-r from-purple-600 to-pink-500 bg-clip-text text-transparent">
									24/7 Premium Support
								</h3>
								<p className="text-gray-700">
									Our dedicated team is always ready to assist
									you with a smile. Experience support that
									goes above and beyond.
								</p>
							</div>
						</div>
					</div>

					{/* Feature 2 */}
					<div className="group relative overflow-hidden rounded-3xl bg-gradient-to-br from-pink-500 to-purple-400 p-1">
						<div className="bg-white rounded-3xl p-8 h-full">
							<div className="relative">
								<span className="mb-6 inline-block rounded-2xl bg-gradient-to-r from-pink-500 to-purple-400 p-4">
									<svg
										className="h-8 w-8 text-white"
										xmlns="http://www.w3.org/2000/svg"
										viewBox="0 0 512 512"
									>
										<path
											fill="currentColor"
											d="M466.5 83.7l-192-80a48.15 48.15 0 0 0-36.9 0l-192 80C27.7 91.1 16 108.6 16 128c0 198.5 114.5 335.7 221.5 380.3 11.8 4.9 25.1 4.9 36.9 0C360.1 472.6 496 349.3 496 128c0-19.4-11.7-36.9-29.5-44.3z"
										/>
									</svg>
								</span>
								<h3 className="mb-4 text-2xl font-bold bg-gradient-to-r from-pink-600 to-purple-500 bg-clip-text text-transparent">
									Rock-Solid Security
								</h3>
								<p className="text-gray-700">
									We craft designs with uncompromising
									security standards that stand the test of
									time.
								</p>
							</div>
						</div>
					</div>

					{/* Feature 3 */}
					<div className="group relative overflow-hidden rounded-3xl bg-gradient-to-br from-purple-400 to-pink-500 p-1">
						<div className="bg-white rounded-3xl p-8 h-full">
							<div className="relative">
								<span className="mb-6 inline-block rounded-2xl bg-gradient-to-r from-purple-400 to-pink-500 p-4">
									<svg
										className="h-8 w-8 text-white"
										xmlns="http://www.w3.org/2000/svg"
										viewBox="0 0 640 512"
									>
										<path
											fill="currentColor"
											d="M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H112C85.5 0 64 21.5 64 48v48H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h272c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H40c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h208c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h208c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H64v128c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"
										/>
									</svg>
								</span>
								<h3 className="mb-4 text-2xl font-bold bg-gradient-to-r from-purple-500 to-pink-600 bg-clip-text text-transparent">
									Lightning Fast Delivery
								</h3>
								<p className="text-gray-700">
									Using cutting-edge tech and agile methods,
									we deliver results at breakthrough speeds.
								</p>
							</div>
						</div>
					</div>
				</div>
			</section>
		</div>
	);
}
